import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { VendorGame } from '~/features/vendor-game/types/vendor-game.type';

/**
 * 벤더 게임 상세 조회
 * @description 벤더 게임 상세 정보를 조회합니다
 * @endpoint GET /admin/vendor-games/:id
 * @param id - 벤더 게임 ID
 * @returns 벤더 게임 정보
 */
export function getVendorGameApi(id: number) {
  return axiosInstance.get<ApiResponse<VendorGame>>(`/admin/vendor-games/${id}`);
}
